import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppConfigService } from '@services/app-config.service';

@Component({
    selector: 'app-error',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class ErrorComponent implements OnInit {
    code: number;
    message: string;
    email: string;

    constructor(
        private route: ActivatedRoute,
        private configSrv: AppConfigService
    ) {}

    ngOnInit() {
        this.code = this.route.snapshot.queryParams["code"];
        this.message = this.route.snapshot.queryParams["message"];
        this.email = this.configSrv.support.email;
    }
}
